import { route as cartRoute } from "@faire/web-api--source/routes/www/cart";
import cartPath from "@faire/web-api--source/routes/www/cart";
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

export const useCartPrefetch = () => {
  const history = useHistory();
  const { prefetch: nextPrefetch } = useRouter();

  return useCallback(
    (href: string = cartRoute) => {
      if (history.location.pathname !== cartPath()) {
        nextPrefetch(href);
      }
    },
    [history.location.pathname, nextPrefetch]
  );
};
